// components/Header.js
import Link from 'next/link';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Menu from './Menu';
import { Menu as MenuIcon } from 'lucide-react';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const router = useRouter();
  const linkColorClass = scrolled ? 'nav-link-black' : 'nav-link-white';

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    // Run once so state matches initial scroll position
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActiveLink = (href) =>
    router.pathname === href ? 'text-primary' : '';

  return (
    <header
      className={
        'fixed top-0 left-0 right-0 w-full z-50 transition-colors transition-shadow duration-500 ease-in-out ' +
        (scrolled ? 'bg-white shadow' : 'bg-transparent')
      }
    >
      <div className="container header-container mx-auto flex items-center justify-between py-9 lg:py-0 px-4">
        <Link href="/">
          <div className="text-center">
            <p className="text-primary text-2xl tracking-[3px] font-gilda uppercase">
              Modern Build
            </p>
            <p
              className={
                (scrolled ? 'text-black' : 'text-white') +
                ' text-xs font-light tracking-[7px] uppercase'
              }
            >
              Home Remodeling
            </p>
          </div>
        </Link>

        <Menu
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          scrolled={scrolled}
          linkColorClass={linkColorClass}
          isActiveLink={isActiveLink}
        />

        <button
          aria-label="Toggle mobile menu"
          className="md:hidden text-primary"
          onClick={() => setIsOpen(!isOpen)}
        >
          <MenuIcon size={24} />
        </button>
      </div>
    </header>
  );
}
